export default {
  cn: {
    login: {
      memberCenter: '销售后台',
      idTxt: '登录账号',
      loginTxt: '账户名称',
      passwordTxt: '交易密码',
      verification: "请输入验证码",
      btn: "登 录",
      language: '请选择语言:',
      hint: "提示",
      tips: {
        loginNoTxt: '请输入登录账号',
        loginNoSure: "账号只能由数字组成",
        passwordNoTxt: "请输入交易密码",
        passwordNoSure: "密码只能由字母或数字组成",
        verifyCodeNoTxt: "请输入验证码",
        verifyCodeNoSure: "验证码错误",
        loginErr: "账号或密码错误"
      },
      select_language: '语言:',
      forgotPassword: '忘记密码?'
    }
  },
  hk: {
    login: {
      memberCenter: '銷售後臺',
      idTxt: '登入帳號',
      loginTxt: '帳戶名稱',
      passwordTxt: '交易密碼',
      verification: "請輸入驗證碼",
      btn: "登 錄",
      language: '請選擇語言:',
      hint: "提示",
      tips: {
        loginNoTxt: '請輸入登錄帳號',
        loginNoSure: "帳號只能由數位組成",
        passwordNoTxt: "請輸入交易密碼",
        passwordNoSure: "密碼只能由字母或數位組成",
        verifyCodeNoTxt: "請輸入驗證碼",
        verifyCodeNoSure: "驗證碼錯誤",
        loginErr: "帳號或密碼錯誤"
      },
      select_language: '語言:',
      forgotPassword: '忘記密碼?'
    }
  },
  en: {
    login: {
      memberCenter: 'Sales Portal Backoffice',
      idTxt: 'login account',
      loginTxt: 'account name',
      passwordTxt: 'passwordTxt',
      verification: "verification",
      btn: "login",
      language: 'language:',
      hint: "hint",
      tips: {
        loginNoTxt: 'Please enter your logon account number',
        loginNoSure: "Accounts can only be made up of numbers",
        passwordNoTxt: "Please enter the transaction password",
        passwordNoSure: "Passwords can only be made up of letters or numbers",
        verifyCodeNoTxt: "Please enter a verification code",
        verifyCodeNoSure: "Verify code error",
        loginErr: "An account or password error"
      },
      select_language: 'Language:',
      forgotPassword: 'Forgot Password?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/login.js